export default "__VITE_ASSET__x7WBc_i___"